module.exports = __webpack_public_path__ + "img/FE_A1_front_en.f9420f3c.png";